<template>
  <div :class="['cy-region-picker',{'cy-region-picker_province':!isShowCity}]">
    <label v-show="isShowTitle">{{ title }}</label>
    <el-select
      :popper-append-to-body="false"
      v-model="curProvince"
      @change="handleCommand('province')"
    >
      <el-option
        v-for="(item, index) in regionList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
    <el-select
      :popper-append-to-body="false"
      v-model="curCity"
      v-show="isShowCity"
      @change="handleCommand('city')"
    >
      <el-option
        v-for="(item, index) in cityList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
    <el-select
      :popper-append-to-body="false"
      v-model="curCounty"
      v-show="isShowCountry"
      @change="handleCommand"
    >
      <el-option
        v-for="(item, index) in countryList"
        :key="index"
        :label="item.name"
        :value="item.id"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    regionList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => ''
    },
    initProvince: {
      type: String,
      default: () => ''
    },
    initCity: {
      type: String,
      default: () => ''
    },
    initCountry: {
      type: String,
      default: () => ''
    },
    // 是否切换地域时折叠地市、区县
    isExpand: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isShowTitle() {
      return this.title !== ''
    },
    // 是否港澳台
    isSpecialRegion() {
      return this.region.indexOf(this.curProvince) !== -1
    },
    isShowCity() {
      let flag = this.isExpand ? this.curProvince !== '86' && !this.isMunicipality : true
      return flag && !this.isSpecialRegion
    },
    isShowCountry() {
      return this.isExpand ? this.curProvince !== '86' && !this.isSpecialRegion : this.isShowCity
    },
    isMunicipality() {
      let filterId = this.curProvince || this.initProvince
      return this.municipality.indexOf(filterId) !== -1
    },
    cityList() {
      let filterId = this.curProvince || this.initProvince
      let result = this.regionList.filter(
        item => String(item.id) === filterId
      )[0]
      if (!result) return []
      return [{ name: '地市', id: '', children: [] }, ...result.children]
    },
    countryList() {
      let filterId = this.curCity || this.initCity
      let result = this.cityList.filter(
        item => String(item.id) === filterId
      )[0]
      if (!result) return [{ name: '区县', id: '', children: [] }]
      return [{ name: '区县', id: '', children: [] }, ...result.children]
    },
    province() {
      let result = this.regionList.find(item => item.id === this.curProvince)
      return result ? result.name : ''
    },
    city() {
      let result = this.cityList.find(item => item.id === this.curCity)
      return result && result.name !== '地市' ? result.name : ''
    },
    county() {
      let result = this.countryList.find(item => item.id === this.curCounty)
      return result && result.name !== '区县' ? result.name : ''
    }
  },
  data() {
    return {
      curProvince: '', // 省
      curCity: '', // 地市
      curCounty: '', // 区县
      // 港澳台
      region: ['820000000000', '810000000000', '710000000000'],
      // 直辖市
      municipality: ['110000000000', '120000000000', '310000000000', '500000000000']
    }
  },
  methods: {
    handleCommand(flag) {
      if (flag === 'province') {
        let index = this.isExpand && this.isMunicipality ? 1 : 0
        this.curCity = this.cityList[index].id
        this.curCounty = ''
      }
      if (flag === 'city') {
        this.curCounty = this.countryList[0].id
      }
      document.body.click()
      this.$emit('handleCommand')
    }
  },
  watch: {
    initProvince: {
      handler(newVal) {
        this.curProvince = newVal || '86'
      },
      immediate: true
    },
    initCity: {
      handler(newVal) {
        this.curCity = newVal === '0' ? '' : newVal
      },
      immediate: true
    },
    initCountry: {
      handler(newVal) {
        this.curCounty = newVal === '0' ? '' : (newVal || '')
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.cy-region-picker {
  display: flex;
  align-items: center;
  label {
    flex-shrink: 0;
  }
  /deep/ .el-select {
    &:nth-child(3),
    &:nth-child(4) {
      margin-left: 10px;
    }
    .el-input {
      &__inner {
        font-family: "founder_youhei_508R";
        background-color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 22px;
      }
    }
  }
}
</style>
